@if (item) {
  <div class="custom-fields">
    <h2>Custom Fields</h2>

    @for (group of form.controls; track index; let index = $index) {
      <div class="custom-fields__item" [formGroup]="group">
        <mat-form-field>
          <mat-hint>{{ group.get('customFieldType')?.value | customFieldType }}</mat-hint>
          <mat-select formControlName="name" placeholder="Select custom field">
            @for (option of allAvailableOptions; track option.key) {
              <mat-option [value]="option.key" [disabled]="option.selected">{{ option.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (group.get('dataType')?.value) {
          @switch (group.get('dataType')?.value) {
            @case ('Text') {
              @if (group.get('allowedValues')?.value) {
                <app-custom-field-dropdown [group]="group"></app-custom-field-dropdown>
              } @else {
                @if (group.get('validators')?.value?.maxLength > 100) {
                  <app-custom-field-textarea [group]="group"></app-custom-field-textarea>
                } @else {
                  <app-custom-field-text [group]="group"></app-custom-field-text>
                }
              }
            }
            @case ('DateTime') {
              <app-custom-field-datepicker [group]="group"></app-custom-field-datepicker>
            }
            @case ('Number') {
              <app-custom-field-number [group]="group"></app-custom-field-number>
            }
            @default {
              <input matInput type="text" formControlName="value" />
            }
          }
        }
        <span class="material-symbols-outlined custom-fields__item--delete" (click)="delete(index)">close</span>
      </div>
    } @empty {
      <div class="custom-fields__empty">The list is empty, add your first custom field</div>
    }
    <button
      class="custom-fields__add"
      mat-stroked-button
      (click)="addGroup()"
      [disabled]="form.controls.length === maxNumberOfFields">
      <span class="material-symbols-outlined">add</span>
    </button>

    <div class="custom-fields__actions">
      <button mat-stroked-button (click)="discardChanges()">Discard changes</button>
      @if (saving) {
        <button mat-flat-button disabled>Saving</button>
      } @else {
        <button mat-flat-button (click)="save()">Save</button>
      }
    </div>
    <div class="custom-fields__notifications-info">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span
        >To enable notifications based on custom fields, please reach out to your local SGL contact. They will assist in
        configuring the setup with the appropriate details.</span
      >
    </div>
  </div>
} @else {
  <app-custom-fields-skeleton></app-custom-fields-skeleton>
}
